import React from "react";
import { IResourceComponentsProps, useForm } from "@refinedev/core";
import Cw8Edit from "components/cw8/Cw8Edit";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import { ChildForm } from "interfaces/schemaDB";


export const CopyRightsEdit: React.FC<IResourceComponentsProps> = () => {

    const resourceLabel :string = 'CopyRight';
    const resourceName :string = 'copyRight';
    const { id } = useForm();
    const childrenForms : ChildForm[] =[
        
    ]

    return(
        <Cw8EditWrapper
            resourceLabel = {resourceLabel}
            resourceName = {resourceName}
            id = {id}
            childrenForms = {childrenForms}
        ></Cw8EditWrapper>
    )
};
